import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import tokens from '../../theme/tokens';

// Tipografia para textos longos (regras, políticas).
const Prose = styled(Box)({
  color: tokens.color.text,
  lineHeight: 1.75,
  '& h1': { fontFamily: tokens.font.display, fontSize: '2rem', margin: '0 0 16px' },
  '& h2': { fontFamily: tokens.font.display, fontSize: '1.45rem', margin: '32px 0 8px', color: tokens.color.text },
  '& h3': { fontSize: '1.05rem', margin: '24px 0 8px' },
  '& p': { margin: '0 0 12px', color: tokens.color.textMuted },
  '& ul, & ol': { paddingLeft: 22, color: tokens.color.textMuted },
  '& li': { marginBottom: 6 },
  '& strong': { color: tokens.color.text },
});

export default Prose;
